module.exports = __webpack_public_path__ + "media/images/homes/Mobile_Responsive_Site@2x-262cdb626c15ff997e60a4da571cc638.png";